import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '../../../../core/i18n';
import { ContainerSizeModule, ResponsiveTableModule } from '../../../../shared';
import { TechnicalAttributesTableComponent } from './technical-attributes-table.component';

@NgModule({
  imports: [CommonModule, I18nModule, ContainerSizeModule, ResponsiveTableModule],
  declarations: [TechnicalAttributesTableComponent],
  exports: [TechnicalAttributesTableComponent],
})
export class TechnicalAttributesTableModule {}
